import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../assets/css/mainMenu.css";
import "../../assets/css/addunit.css";

import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import ArrowDown from "../../assets/icons2/ArrowDown.svg";
import trash from "../../assets/icons/trash.svg";
import ArrowUp from "../../assets/icons2/ArrowUp.svg";
import plus1 from "../../assets/icons/plus1.svg";
import search2 from "../../assets/icons/search2.svg";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import Pagination from "../../Components/Pagination/Pagination";
import { hasPermission } from "../../Services/authUtils";

const TemplateList = () => {
  const [loading, setLoading] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [templateType, setTemplateType] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [actionTemplateId, setActionTemplateId] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "created_at",
    order: "asc",
  });
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);

  const navigate = useNavigate();
  const { id } = useParams();

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchTemplates(); // Perform search
    }
  };

  useEffect(() => {

    fetchTemplates();
  }, [
    id,
    page,
    pageSize,
    sortBy,
    // search,
    totalPages,
    currentPage,
    totalItems,
    templateList.length,
    confirmModal,
  ]);

  const fetchTemplates = async () => {
    const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}&template_type_id=${id}`;

    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template/paginate${queryString}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate // Include navigate if needed for error handling
      );

      setTemplateList(data.templates);
      setTemplateType(data.templateType.template_type_name);
      setTotalPages(data.totalPages);
      setTotalItems(data.totalItems);
      setCurrentPage(data.currentPage);

    } catch (error) {
      console.error("Error fetching Template Lists:", error.message);
      if (error.message === "Unauthorized") {
        navigate("/auth/login"); // Navigate to login if unauthorized
      }
    }
  };

  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const handleToggleUserStatus = (templateId) => {
    setActionTemplateId(templateId);
    setConfirmModal(true);
  };

  const confirmAction = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template/delete/${actionTemplateId}`;

    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
        },
        navigate // Include navigate for error handling
      );

      setLoading(false);
      setConfirmModal(false);
      toast.success("Template Delete Successful");
    } catch (error) {
      setLoading(false);
      setConfirmModal(false);
      console.error("Error deleting template:", error.message);
      toast.error(`Error deleting template: ${error.message}`);

      if (error.message === "Unauthorized") {
        navigate("/auth/login"); // Navigate to login if unauthorized
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <div className="container">
            <div className="show-breadcrumb pt-3">
              <div className="">
                <h5>{templateType ? templateType : "Loading..."}</h5>

                <nav className="breadcrumb-nav" aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a className="">Templates</a>
                    </li>

                    <li className="breadcrumb-item active" aria-current="page">
                      {templateType ? templateType : "Loading..."}
                    </li>
                  </ol>
                </nav>
                <div className="">
                  <div
                    className="navbar-3 d-flex justify-content-between"
                    style={{ marginTop: "-3px" }}
                  >
                    <div className="search-container ">
                      <img src={search2} alt="Search" />
                      <input
                        type="text"
                        className=""
                        id="search"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Search "
                        autoComplete="off"
                      />
                    </div>

                    {hasPermission(["templates.create"]) && (
                      <div>
                        <button
                          type="button"
                          id="openPopup"
                          className="btn-bg"
                          onClick={() =>
                            navigate(`/template_types/${id}/create`)
                          }
                        >
                          <span className="plus-icon">
                            <img src={plus1} alt="Plus Icon" />
                          </span>
                          CREATE NEW TEMPLATE
                        </button>
                      </div>
                    )}
                  </div>
                  <div style={{ marginTop: "-10px" }}>
                    <div className="table-responsive">
                      <table className="table  align-middle table-text">
                        <thead className="table-head align-middle">
                          <tr>
                            {/* <th className="table-check">
                              <input type="checkbox" />
                            </th> */}
                            <th>ID</th>
                            <th
                              className="col text-uppercase"
                              onClick={() => handleSortChange("template_code")}
                            >
                              Template Code{" "}
                              {sortBy.field === "template_code" && (
                                <span>
                                  {sortBy.order === "asc" ? (
                                    <img src={ArrowUp} alt="ArrowUp" />
                                  ) : (
                                    <img src={ArrowDown} alt="ArrowDown" />
                                  )}
                                </span>
                              )}
                            </th>
                            <th
                              className="col text-uppercase"
                              onClick={() => handleSortChange("template_name")}
                            >
                              Template Name{" "}
                              {sortBy.field === "template_name" && (
                                <span>
                                  {sortBy.order === "asc" ? (
                                    <img src={ArrowUp} alt="ArrowUp" />
                                  ) : (
                                    <img src={ArrowDown} alt="ArrowDown" />
                                  )}
                                </span>
                              )}
                            </th>

                            {(hasPermission(["templates.update"]) ||
                              hasPermission(["templates.delete"])) && (
                                <th className="col-2 text-uppercase">ACTION</th>
                              )}
                          </tr>
                        </thead>
                        <tbody className="pl-4">
                          {templateList.map((template, rowIndex) => (
                            <tr key={template._id}>
                              {/* <td className="table-check">
                                <input type="checkbox" />
                              </td> */}
                              <td>{rowIndex + startIndex}</td>
                              <td className="col">{template.template_code}</td>
                              <td className="col">{template.template_name}</td>
                              {(hasPermission(["templates.update"]) ||
                                hasPermission(["templates.delete"])) && (
                                  <td>
                                    <div className="action-icons d-flex justify-content-left align-items-center ">
                                      {template.status &&
                                        hasPermission(["templates.update"]) && (
                                          <button
                                            style={{
                                              border: "none",
                                              background: "transparent",
                                            }}
                                            className="align-content-center me-3"
                                            onClick={() =>
                                              navigate(
                                                `/template_types/${id}/edit/${template._id}`
                                              )
                                            }
                                            disabled={!template.status}
                                          >
                                            <img src={edit} alt="edit" />
                                          </button>
                                        )}

                                      {hasPermission(["templates.delete"]) && (
                                        <button
                                          style={{
                                            border: "none",
                                            background: "transparent",
                                          }}
                                          className="align-content-center"
                                          onClick={() =>
                                            handleToggleUserStatus(template._id)
                                          }
                                        >
                                          <img src={trash} alt="trash" />
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    pageSize={pageSize}
                    onPageSizeChange={handlePageSizeChange}
                    totalItems={totalItems}
                    startIndex={startIndex}
                    endIndex={endIndex}
                  />
                </div>
              </div>
            </div>

            {/* Confirmation Modal */}
            <div
              id="overlay"
              className={`modal fade ${confirmModal ? "show" : ""}`}
              tabIndex="-1"
              role="dialog"
              style={{
                zIndex: 30,
                display: confirmModal ? "block" : "none",
                transition: "width 2s",
              }}
            >
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>Delete Template</h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setConfirmModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>
                  <div className="addunit-form">
                    <p>Are you sure you want to delete this template?</p>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="update-btn"
                      onClick={confirmAction}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default TemplateList;
